import flyttPkbReducer from "./flyttPkbReducer";

export default flyttPkbReducer;
